import { useCallback, useState } from "react";
import { Box, Button, IconButton, Typography, Alert } from "@mui/material";
import { mockDepartmentFields } from "../../data/mockDepartmentData";
import { departmentSchema } from "../../schema/departmentSchema";
import { useNavigate } from "react-router-dom";
import { createDepartment } from "../../api/department";
import AuthForm from "../shared/AuthForm";
import ModalContainer from "./ModalContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const initialValues = {
  department_name: "",
};

const CreateDepartmentModal = ({ openModal, setOpenModal, colors }) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();
  
  const handleGoBack = () => {
    navigate(-1);

    setOpenModal(false);
  };

  const handleFormSubmit = useCallback(async (values) => {
    try {
      await createDepartment(values);
      setOpenModal(false);
    } catch (error) {
      setAlertMessage(error.message);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  }, [setOpenModal]);

  return (
    <ModalContainer
      openModal={openModal}
      setOpenModal={setOpenModal}
      colors={colors}
    >
      <Box textAlign="start" onClick={handleGoBack}>
        <IconButton sx={{ marginRight: "5px" }}>
          <ArrowBackIcon />
        </IconButton>
        Back to home
      </Box>
      <Typography variant="h1" my={3} color="text.primary">
        Create Department
      </Typography>
      {/* Alert */}
      {showAlert && (
        <Box my={2}>
          <Alert variant="filled" severity="error">
            {alertMessage}
          </Alert>
        </Box>
      )}
      <AuthForm
        initialValues={initialValues}
        validationSchema={departmentSchema}
        fields={mockDepartmentFields}
        onSubmit={handleFormSubmit}
      >
        <Box display="flex" justifyContent="end" mt="20px">
          <Button type="submit" color="secondary" variant="contained">
            Submit
          </Button>
        </Box>
      </AuthForm>
    </ModalContainer>
  );
};

export default CreateDepartmentModal;
